import React, { useEffect, useState } from "react";
import { kpiGetTeamOtherActivityByIdAndMonth } from "../../../config/apiSPA";
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "react-bootstrap";
import { getMonthName } from "../../../components/dateFormater/monthToText";
import ColorApp from "../../../components/color/color";
const presetData = {
  id: null,
  kpiName: null,
  month: null,
  year: null,
  totalTarget: null,
  totalActual: null,
  list: [],
};
const ModalOtherDetail = ({ show, onClose, data }) => {
  const [result, setResult] = useState(presetData);
  const [loading, setLoading] = useState(false);
  const getBgColor = (target, actual) => {
    if (target === 0 && actual === 0) return "";
    if (target === 0) return { backgroundColor: ColorApp().themeColor };
    if (actual === 0) return { backgroundColor: "#dc3545" };
    if (target > actual) return { backgroundColor: "#ffc107", color: "#000" };

    return { backgroundColor: ColorApp().themeColor };
  };
  const loadData = async () => {
    try {
      const res = await kpiGetTeamOtherActivityByIdAndMonth(data?.kpiId, data?.year, data?.month);
      setLoading(false);
      setResult(res);
    } catch (error) {}
  };
  useEffect(() => {
    if (show) {
      setLoading(true);
      loadData();
    } else {
      setLoading(true);
    }
  }, [show]);
  return (
    <Modal show={show} onHide={onClose}>
      <ModalHeader closeButton>
        <h5 className="modal-title">Detail</h5>
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <>
            {result.list.length > 0 ? (
              <>
                <h6>{result.kpiName}</h6>
                <div className="d-flex gap-2 mb-3">
                  <span className="badge  text-bg-secondary">📅 Month: {getMonthName(result.month)}</span>

                  <span className="badge  text-bg-info">🗓️ Year: {result.year}</span>
                </div>
                <ul className="list-group">
                  {result.list.map((item, index) => (
                    <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                      <span>{item.instructor}</span>
                      <span className="badge" style={getBgColor(item.target, item.actual)}>
                        {item.actual}/{item.target}
                      </span>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <p className="text-muted mb-0">Tidak ada data mentoring.</p>
            )}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Got It
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalOtherDetail;
